import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const KEY = "krv_cookie_consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) {
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const decide = (value) => {
    try { localStorage.setItem(KEY, value); } catch (e) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 sm:px-6 animate-in slide-in-from-bottom-6 duration-500"
    >
      <div className="relative max-w-5xl mx-auto rounded-xl border border-gold/25 bg-navy-deep/95 backdrop-blur-md shadow-2xl grain">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4 p-5 sm:p-6">
          <div className="flex items-start gap-3 flex-1">
            <span className="mt-0.5 h-9 w-9 shrink-0 inline-flex items-center justify-center rounded-md border border-gold/30 text-gold">
              <Cookie className="h-4 w-4" />
            </span>
            <p className="text-sm leading-relaxed text-slate-300">
              We use cookies to keep you signed in, remember your preferences and understand how the site is used so we
              can improve it. See our{" "}
              <Link to="/privacy" className="text-gold hover:underline underline-offset-2" data-testid="cookie-privacy-link">
                Privacy Policy
              </Link>{" "}
              for details.
            </p>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <button
              data-testid="cookie-decline-btn"
              onClick={() => decide("declined")}
              className="text-sm font-medium text-slate-400 hover:text-white transition-colors px-3 py-2"
            >
              Decline
            </button>
            <button
              data-testid="cookie-accept-btn"
              onClick={() => decide("accepted")}
              className="text-sm font-semibold rounded-md bg-gold text-navy-deep px-5 py-2.5 hover:bg-gold/90 transition-colors"
            >
              Accept
            </button>
          </div>
          <button
            aria-label="Dismiss"
            data-testid="cookie-dismiss-btn"
            onClick={() => decide("dismissed")}
            className="absolute top-3 right-3 sm:static sm:hidden text-slate-500 hover:text-white transition-colors"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
